import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Grid, Link, Typography, useTheme, useMediaQuery } from "@mui/material";
import { profilePrivacyPath } from "../Privacy/constants";
import FeedbackWidget from "../components/feedback/FeedbackWidget";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        py: isMobile ? 2 : 1.4,
        mt: "auto",
        borderTop: "1px solid",
        borderColor: "divider",
        color: theme.palette.text.secondary,
        backgroundColor: "transparent",
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={isMobile ? 1.5 : 3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid size={{ xs: 12, sm: 4 }} textAlign={isMobile ? "center" : "left"}>
            <Typography variant="body2" sx={{ mt: isMobile ? 0 : 1, fontSize: isMobile ? 12 : undefined }}>
              © {new Date().getFullYear()} HireVeda. All rights reserved.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }} textAlign={isMobile ? "center" : "right"}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: isMobile ? 1.5 : 1.5,
                justifyContent: isMobile ? "center" : "flex-end",
              }}
            >
              <Link
                component={RouterLink}
                to={profilePrivacyPath("data-privacy")}
                color="inherit"
                underline="hover"
                sx={{ fontSize: isMobile ? 12 : undefined }}
              >
                Privacy
              </Link>
              <Link
                component={RouterLink}
                to={profilePrivacyPath("legal")}
                color="inherit"
                underline="hover"
                sx={{ fontSize: isMobile ? 12 : undefined }}
              >
                Terms
              </Link>
              <Link
                href="https://hireveda.com/refund-terms/"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="hover"
                sx={{ fontSize: isMobile ? 12 : undefined }}
              >
                Refunds
              </Link>
              <Link
                href="https://hireveda.com/blog"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="hover"
                sx={{ fontSize: isMobile ? 12 : undefined }}
              >
                Blog
              </Link>
              <FeedbackWidget
                variant="link"
                align="end"
                style={{ fontSize: isMobile ? 12 : undefined }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
